<div [formGroup]="form">
  <mtn-text-field [form]="form" controlName="name"
                  [placeholder]="'editCompany.name' | translate"
                  [isRequired]="true">
  </mtn-text-field>

  <mtn-text-area-field [form]="form" controlName="description"
                       [placeholder]="'editCompany.description' | translate"
                       [maxLength]="255">
  </mtn-text-area-field>
</div>
